<template>
    <md-content class="card">
        <md-table v-model="contracts" :md-alingment="right">
            <md-table-row slot="md-table-row" slot-scope="{ item, index }" class="md-accent"
                          @mouseover="currentHoverIndex = index"
                          @mouseleave="currentHoverIndex = null">
                <md-table-cell :md-label="$t('views.contract.list.table.label.id')">{{ getNo(index) }}</md-table-cell>
              <md-table-cell :md-label="$t('views.contract.list.table.label.signedBy')">{{ item.temporarySignedBy ? item.temporarySignedBy : " " }}</md-table-cell>
              <md-table-cell :md-label="$t('views.contract.list.table.label.signedAt')">{{ item.temporarySignedAt && item.temporarySignedAt | moment('L LT') }}</md-table-cell>
              <md-table-cell :md-label="$t('views.contract.list.table.label.signedBy')">{{ item.signedBy ? item.signedBy : "" }}</md-table-cell>
                <md-table-cell :md-label="$t('views.contract.list.table.label.signedAt')">{{ item.signedAt && item.signedAt | moment('L LT') }}</md-table-cell>
              <md-table-cell :md-label="$t('views.contract.list.table.label.expectedFinalPrice')">{{ formatLocaleNumber(item.expectedFinalPrice) }}</md-table-cell>
              <md-table-cell :md-label="$t('views.contract.list.table.label.status')">
                    {{ item.signed ? 'Podpisany' : 'Nie podpisany' }}
                </md-table-cell>
              <div class="actions-contracts" v-if="currentHoverIndex == index" :style="setActionPosition">
                  <button-spinner class="like-icon-button" 
                  :disabled="item.inSigningProcess" :is-loading="item.inSigningProcess"
                  v-if="!item.signed && hasAccess('PRIVILEGE_CONTRACT_SIGN') && checkUserType()" 
                  @click.native="signContract(item.id)">
                    <md-tooltip md-direction="top">{{ $t('signDocument') }}</md-tooltip>
                    <md-icon>assignment_turned_in</md-icon>
                  </button-spinner>
                  <md-button class="md-icon-button" v-if="hasAccess('PRIVILEGE_ORDER_GET')" @click="openPdf(item.id)">
                    <md-tooltip md-direction="top">{{ $t('showDocument') }}</md-tooltip>
                    <md-icon>description</md-icon>
                  </md-button>
                </div>
            </md-table-row>
            <md-table-empty-state v-if="!loading" class="md-layout-item md-size-100" :md-label="$t('dialog.noData')" />
            <Spiner :loading="loading" />
        </md-table>
    </md-content>
</template>

<script>
  import {ordersEndpoint} from '@/services/adsign-backend/endpoints'
  import sortSupport from '@/mixins/sortSupport';
  import Spiner from '@/components/Spiner'
  import router from '@/router';
  import {mapGetters} from "vuex";
  import orderCommons from '@/mixins/orderCommons';
  import ButtonSpinner from 'vue-button-spinner'

  export default {
    name: 'ContractsList',
    mixins: [sortSupport, orderCommons],
    components: {Spiner, ButtonSpinner},
    computed: {
      ...mapGetters('auth', ['hasAccess']),
      ...mapGetters('auth', ['userType']),
      setActionPosition() {
        if (this.position === 1) {
          return "margin-right: -100%";
        } else {
          return "margin-right: -200%";
        }
      }
    },
    props: {
      orderId: {
            type: [Number, String],
            default: undefined,
        },
      position:{
        type: Number,
        default: undefined
      }
    },
    data: () => ({
      contracts: [],
      currentHoverIndex: null,
      loading: false,
      contractsChecker: null
    }),
    mounted(){
      this.loadContracts();
      this.checkContractInProgressStatus();
      this.contractsChecker = setInterval(() => this.checkContractInProgressStatus(),10000);
    },
    beforeDestroy(){
      clearInterval(this.contractsChecker);
    },
    methods: {
      loadContracts() {
        this.loading = true
        ordersEndpoint.getContracts(this.orderId)
        .then(result => {
          this.contracts = result.data
          this.contracts.forEach((item) => {
            if (item.inSigningProcess == undefined) {
              item.inSigningProcess = true
            }
          })
        })
        .catch(this.handleServerValidationError)
        .finally(() => this.loading = false)
      },
      openPdf(contractId){
        ordersEndpoint.getContractFile(this.orderId, contractId).then( result => {
          let blob = new Blob([result.data], { type: 'application/pdf' })
          let url = window.URL.createObjectURL(blob)
          window.open(url, "_blank")
          })
      },
      signContract(contractId){
        let contractIndex = this.contracts.findIndex(contract => contract.id === contractId)
        this.contracts[contractIndex].inSigningProcess = true;
        ordersEndpoint.signContract(this.orderId, contractId)
        .finally(() => {
          this.loadContracts()
        })
      },
      checkUserType(){
        if(this.userType === 'CLIENT_USER' || this.userType === 'CLIENT_ADMIN')
          return true
        return false
      },
      checkContractInProgressStatus(){
        ordersEndpoint.getContractsInProgressSet(this.orderId).then(result => {
          this.contracts.forEach(contract => {
            if (result.data.indexOf(contract.id) != -1) {
              contract.inSigningProcess = true;
            } else {
              contract.inSigningProcess = false;
            }
          })
        })
      }

    }
  }
</script>

<style scoped>
.like-icon-button{
    margin-top: 3px;
    size: 10px !important;
    border: none !important;
    border-radius: 0% !important;
}
</style>
